import CryptoJS from 'crypto-js'
import secureLocalStorage from 'react-secure-storage'

function bufferToHex(buf) {
  return buf.data.map(b => b.toString(16).padStart(2, '0')).join('')
}

function getKeyIv() {
  let keyStored = secureLocalStorage.getItem('key')
  let ivStored = secureLocalStorage.getItem('iv')

  let keyHex = typeof keyStored === 'object' && keyStored.type === 'Buffer'
    ? bufferToHex(keyStored)
    : keyStored

  let ivHex = typeof ivStored === 'object' && ivStored.type === 'Buffer'
    ? bufferToHex(ivStored)
    : ivStored

  let key = CryptoJS.enc.Hex.parse(keyHex)
  let iv = CryptoJS.enc.Hex.parse(ivHex)

  return { key, iv }
}

export function decryptMessage(encryptedInput) {
  let { key, iv } = getKeyIv()

  let encryptedHex
  if (typeof encryptedInput === 'object' && encryptedInput.type === 'Buffer') {
    encryptedHex = bufferToHex(encryptedInput)
  } else if (typeof encryptedInput === 'string') {
    encryptedHex = encryptedInput
  } else {
    return ''
  }

  try {
    let cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Hex.parse(encryptedHex)
    })
    let decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
    let plain = decrypted.toString(CryptoJS.enc.Utf8)
    return plain || encryptedHex
  } catch {
    return encryptedHex
  }
}

export function encryptMessage(plainText) {
  let { key, iv } = getKeyIv()

  let encrypted = CryptoJS.AES.encrypt(plainText, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.ciphertext.toString(CryptoJS.enc.Hex)
}
